/* eslint-disable jira/filename-case, jira/import-whitelist, jira/naming/disallow-filenames */
import { loadQuery, type PreloadedQuery } from 'react-relay';
import QUERY, {
	type SandboxEchoPageQuery,
} from '@jira/spa-apps__sandbox-relay/src/ui/__generated__/SandboxEchoPageQuery.graphql';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';
import { QueryPromisesMap } from '@atlassian/relay-query-promises';
import { RELAY_RESOURCE_TYPE } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';

export const sandboxEchoPageRelayResource: RouteResource<
	PreloadedQuery<SandboxEchoPageQuery, Record<string, unknown>>
> = createResource<PreloadedQuery<SandboxEchoPageQuery>>({
	type: `${RELAY_RESOURCE_TYPE}_SANDBOX_RELAY_DEFER_ECHO`,
	getKey: () => 'sandbox-relay-defer-echo',
	// @ts-expect-error - might return null
	getData: async (routerContext, { tenantContext }) => {
		// SSR/AGG does not currently work for anonymous users and returns a 403. We should enable anonymous SSR once
		// the underlying auth issues have been fixed. See more details here https://hello.atlassian.net/wiki/spaces/~hkim/pages/1853841608/Why+are+Jira+SSR+requests+to+AGG+not+working+for+anonymous+users
		if (__SERVER__ && tenantContext.isAnonymous) {
			return null;
		}

		// Bail if the request opted out of SSR rendering
		if (__SERVER__ && 'ssr' in routerContext.query && routerContext.query.ssr === 'false') {
			return null;
		}

		const variables = {
			cloudId: tenantContext.cloudId,
			enableDefer: Boolean(
				'defer' in routerContext.query ? routerContext.query.defer === 'true' : true,
			),
			skipLongQuery: Boolean(
				'skipLong' in routerContext.query ? routerContext.query.skipLong === 'true' : true,
			),
		};
		const options = { fetchPolicy: 'store-and-network' } as const;

		const queryReference = loadQuery(getRelayEnvironment(), QUERY, variables, options);

		if (__SERVER__ && queryReference.id != null) {
			await QueryPromisesMap.get(queryReference.id);
		}

		return queryReference;
	},
	maxAge: 0,
});
